import React, {Component} from 'react';
import {Modal} from "react-bootstrap";
import './index.css';

class DMPlayer extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let old_width = window.design_editor.design.base_width;
        var design_aspect = window.design_editor.design.get_width()/window.design_editor.design.get_height();
        var screen_aspect = window.innerWidth/window.innerHeight
        var new_width
        if(design_aspect > screen_aspect){
            new_width = 0.7 * window.innerWidth
        }else{
            new_width = design_aspect*0.7*window.innerHeight
        }
        window.design_editor.design.base_width = new_width
        window.design_editor.design.handleWindowResize()
        window.design_editor.draw();
        this.pages = window.design_editor.design.generateAnimatedContentExportStruct();

        window.design_editor.design.base_width = old_width
        window.design_editor.handleWindowResize()
        window.design_editor.draw()
        this.remapIds()
        this.animatePage(0)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.design !== this.props.design) {}
    }

    remapIds() {
        for (let i = 0; i < this.pages.length; i++) {
            for (let j = 0; j < this.pages[i].elements.length; j++) {
                let old_id = this.pages[i].elements[j].domNodeId;
                let new_id = window.utils.uuidv4();
                this.pages[i].elements[j].domNodeId = new_id;
                let reg_exp = new RegExp(old_id, 'g');
                this.pages[i].dom = this.pages[i].dom.replace(reg_exp, new_id);
            }
        }
    }

    animatePage(pageIndex) {
        if (pageIndex >= this.pages.length) {
            return;
        }
        var self = this;
        const timeout = self.pages[pageIndex]['duration'] * 1000;
        let playerContainerNode = document.getElementById("dm_anim_player_div");
        if (playerContainerNode === null) {
            //player closed while animation was running
            return;
        }
        playerContainerNode.innerHTML = '';
        playerContainerNode.innerHTML = this.pages[pageIndex].dom;

        const animatedElements = self.pages[pageIndex].elements.filter(x => x['animationClass'] !== "" && x['animationClass'] !== "none");
        if (animatedElements.length > 0) {
            const exitAnimDelay = timeout - 1000 - (animatedElements.length * 100);
            this.animateObjectsInPage(pageIndex);
            if (pageIndex !== this.pages.length - 1) {
                setTimeout(function () {
                    self.triggerExitAnimations(pageIndex);
                }, exitAnimDelay)
            }
        }
        setTimeout(function () {
            self.animatePage(pageIndex + 1);
        }, timeout)
    }

    triggerExitAnimations(pageIndex = 0) {
        const sortedElementsArray = this.pages[pageIndex].elements.filter(x => x['animationClass'] !== "" && x['animationClass'] !== 'none').sort((a, b) => (a['layerIndex'] - b['layerIndex']));
        this.runExitAnimation(sortedElementsArray, 0);
    }

    animateObjectsInPage(pageIndex) {
        const sortedElementsArray = this.pages[pageIndex].elements.filter(x => x['animationClass'] !== "" && x['animationClass'] !== 'none').sort((a, b) => (a['layerIndex'] - b['layerIndex']));
        sortedElementsArray.forEach(obj => {
            let dom_node = document.getElementById(obj.domNodeId);
            if (dom_node !== null) {
                dom_node.style['display'] = 'none';
            }
        });
        this.runAnimation(sortedElementsArray, 0);
    }

    runAnimation(sortedElementsArray, idx = 0) {
        if (idx >= sortedElementsArray.length) return;
        var self = this;
        let element = sortedElementsArray[idx];
        let dom_node = document.getElementById(element.domNodeId);
        if (dom_node === null) {
            return;
        }
        dom_node.style['display'] = 'block';
        this.animateObject(dom_node, element.animationClass, element.easeSetting, element.animationDuration, element.extra_rotation_angle, element.extraOpacity);
        idx += 1;
        setTimeout(function () {
            self.runAnimation(sortedElementsArray, idx);
        }, 100);
    }

    runExitAnimation(sortedElementsArray, idx = 0) {
        if (idx >= sortedElementsArray.length) return;
        var self = this;
        let element = sortedElementsArray[idx];
        let dom_node = document.getElementById(element.domNodeId);
        if (dom_node === null) {
            return;
        }
        this.animateObject(dom_node, element.animationClass, element.easeSetting, element.animationDuration, element.extra_rotation_angle, element.extraOpacity, 'reverse')
            .then(() => {
                if (dom_node !== null) {
                    dom_node.style['display'] = 'none';
                }
            })

        idx += 1;
        setTimeout(function () {
            self.runExitAnimation(sortedElementsArray, idx);
        }, 100);
    }

    animateObject(domNode, animationClass, easeSetting, animationDuration, extra_rotation_angle, extraOpacity, animationDirection = 'normal') {
        return new Promise((resolve, reject) => {
            domNode.style.setProperty('--m', extra_rotation_angle);
            domNode.style.setProperty('--n', extraOpacity);
            domNode.style['animation'] = animationClass + ", extra-rotation, extra-opacity";
            if (easeSetting && easeSetting !== "") {
                domNode.style['animationTimingFunction'] = easeSetting;
            }
            if (animationDirection === 'reverse') {
                domNode.style['animationDuration'] = '1s';
            }
            else {
                domNode.style['animationDuration'] = animationDuration;
            }
            domNode.style['animationDirection'] = animationDirection;

            function handleAnimationEnd(event) {
                event.stopPropagation();
                domNode.style.removeProperty('animation');
                domNode.style.removeProperty('animationTimingFunction');
                domNode.style.removeProperty('animationDuration');
                domNode.style.removeProperty('animationDirection');
                resolve('Animation ended');
            }

            domNode.addEventListener('animationend', handleAnimationEnd, {once: true});
        });
    }

    render() {
        return (
            <div id="dm_anim_player_div">
            </div>
        )
    }
}

class DMPlayerModal extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.hide}
                dialogClassName="animations-player-modal"
            >
                <Modal.Body>
                    <DMPlayer
                        design={this.props.design}
                    />
                </Modal.Body>
            </Modal>
        );
    }

}

export default DMPlayer;
export {DMPlayerModal};